module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/cleaner-icon-7d94e041c3f16a13dffa1426b8586929.png";